import React, {useState} from "react";
import "./Contact.scss";
import { useSelector, useDispatch } from "react-redux";
import { uiActions } from "../../store/ui-slice";
import {sendContactformAplication, sendJobApplicationEmail} from "../../actions/pages-actions";

const Contact = () => {
	const dispatch = useDispatch();

	const [formData, setFormData] = useState({
		help_for: "",
		name: "",
		email: "",
		phone: "",
		company: "",
		role: "",
		interest_in_1: "",
		interest_in_2: "",
		interest_in_3: "",
		interest_in_4: "",
		message: "",
		budget: "",
	});

	const [submitted, setSubmitted] = useState(false);
	const [step, setStep] = useState(1);
	const [error, setError] = useState("");
	const goToStep = ( new_step ) => {
		if ( new_step === 4 ) {
			handleSubmit();
		}
		setStep( new_step );
	};
	const handleChange = (e) => {
		const { name, value } = e.target;
		console.log(name,value, formData);
		if ( name === 'interest_in_1' || name === 'interest_in_2' || name === 'interest_in_3' || name === 'interest_in_4' ) {
			let $mapper = {
				'interest_in_1' : 'Product Discovery',
				'interest_in_2' : 'Product Design',
				'interest_in_3' : 'Product Development',
				'interest_in_4' : 'Product Growth',
			}
			if ( formData[name] === $mapper[name] ) {
				setFormData((prevData) => ({
					...prevData,
					[name]: '',
				}));
				return;
			}
		}

		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {

		try {
			await dispatch(
				sendContactformAplication( formData )
			);
			setSubmitted(true);
			setError("");
		} catch (err) {
			setError(err.message);
			console.error("Application submission error:", err.message);
		}

		setFormData({
			help_for: "",
			name: "",
			email: "",
			phone: "",
			company: "",
			role: "",
			interest_in_1: "",
			interest_in_2: "",
			interest_in_3: "",
			interest_in_4: "",
			message: "",
			budget: "",
		});

		setTimeout(() => setSubmitted(false), 3000);
	};
	const contactOpened = useSelector((state) => state.ui.contactOpen);

	const toggleContact = () => {
		dispatch(uiActions.toggleContact());
	};

	return (
		<section className={`contact-section ${contactOpened ? "active" : ""}`}>
			<div className={"container"}>
                    <span className={"close-button"} onClick={toggleContact}>
                         &times;
                    </span>
				<div className={"row"}>
					<div className={"col-7 offset-1"}>
						<form>
							<div className={'step step-1 ' + (step === 1 ? 'active' : '')}>
								<h2>Let’s work together</h2>
								<p>
									Fill out the form and we’ll get back to you within 24 hours.
									Alternatively, email us at hello@webpigment.com
								</p>
								<fieldset>
									<div className={"field"}>
										<h4>What can we help you with?</h4>
										<ul>
											<li>
												<label>
													<input
														type={"radio"}
														name={"help_for"}
														value={"Your new great project"}
														onChange={handleChange}
														checked={formData.help_for === 'Your new great project' ? 'checked' : '' }
													/>{" "}
													<span>Your new great project</span>
												</label>
											</li>
											<li>
												<label>
													<input
														type={"radio"}
														name={"help_for"}
														value={"Existing website"}
														onChange={handleChange}
														checked={formData.help_for === 'Existing website' ? 'checked' : '' }
													/>{" "}
													<span>Existing website</span>
												</label>
											</li>
											<li>
												<label>
													<input
														type={"radio"}
														name={"help_for"}
														value={"Plan a call"}
														onChange={handleChange}
														checked={formData.help_for === 'Plan a call' ? 'checked' : '' }
													/>{" "}
													<span>Plan a call</span>
												</label>
											</li>
											<li>
												<label>
													<input
														type={"radio"}
														name={"help_for"}
														value={"Meeting for a coffee"}
														onChange={handleChange}
														checked={formData.help_for === 'Meeting for a coffee' ? 'checked' : '' }
													/>{" "}
													<span>Meeting for a coffee</span>
												</label>
											</li>
										</ul>
									</div>
									<div className={"field"}>
										<button className={"btn btn-1"} onClick={(e) => {
											e.preventDefault();
											goToStep(2)
										}}>Next
										</button>
									</div>
								</fieldset>
							</div>
							<div className={'step step-2 ' + (step === 2 ? 'active' : '')}>
								<span className={'go-back'} onClick={(e) => {
									e.preventDefault();
									goToStep(1)
								}}>
									<svg width="19" height="15" viewBox="0 0 19 15" fill="none"
									     xmlns="http://www.w3.org/2000/svg">
									    <path
										    d="M7.402 12.4105C7.78545 12.7939 7.78545 13.3976 7.402 13.7811C7.01854 14.1516 6.41486 14.1516 6.03141 13.7811L0.287359 8.03789C0.109449 7.85998 -0.000230789 7.61298 -0.000230789 7.3392C-0.000230789 7.06543 0.109449 6.81843 0.287359 6.63966L6.03141 0.896478C6.41486 0.513023 7.01854 0.513023 7.402 0.896478C7.78545 1.27993 7.78545 1.88361 7.402 2.26707L3.28936 6.36589L17.8891 6.36589C18.4237 6.36502 18.8486 6.80375 18.8486 7.33834C18.8486 7.87293 18.4237 8.29784 17.8891 8.29784H3.29022L7.402 12.4105Z"
										    fill="#009FE3"/>
									</svg>
									Go back
								</span>
								<h2>How can we reach you?</h2>
								<fieldset>
									<div className={"field"}>
										<input
											type={'text'}
											name={'name'}
											placeholder={'Your name'}
											value={formData.name}
											onChange={handleChange}
											required
										/>
									</div>
									<div className={"field"}>
										<input
											type={'email'}
											name={'email'}
											placeholder={'Email Address'}
											value={formData.email}
											onChange={handleChange}
											required
										/>
									</div>
									<div className={"field"}>
										<input
											type={'tel'}
											name={'phone'}
											placeholder={'Phone Number ( optional )'}
											value={formData.phone}
											onChange={handleChange}
											required
										/>
									</div>
									<div className={"field"}>
										<input
											type={'text'}
											name={'company'}
											placeholder={'Company ( optional )'}
											value={formData.company}
											onChange={handleChange}
										/>
									</div>
									<div className={"field"}>
										<input
											type={'text'}
											name={'role'}
											placeholder={'Your role ( optional )'}
											value={formData.role}
											onChange={handleChange}
										/>
									</div>
									<div className={"field"}>
										<button className={"btn btn-1"} onClick={(e) => {
											e.preventDefault();
											goToStep(3)
										}}>Next
										</button>
									</div>
								</fieldset>
							</div>
							<div className={'step step-3 ' + (step === 3 ? 'active' : '')}>
								<span className={'go-back'} onClick={(e) => {
									e.preventDefault();
									goToStep(2)
								}}>
									<svg width="19" height="15" viewBox="0 0 19 15" fill="none"
									     xmlns="http://www.w3.org/2000/svg">
									    <path
										    d="M7.402 12.4105C7.78545 12.7939 7.78545 13.3976 7.402 13.7811C7.01854 14.1516 6.41486 14.1516 6.03141 13.7811L0.287359 8.03789C0.109449 7.85998 -0.000230789 7.61298 -0.000230789 7.3392C-0.000230789 7.06543 0.109449 6.81843 0.287359 6.63966L6.03141 0.896478C6.41486 0.513023 7.01854 0.513023 7.402 0.896478C7.78545 1.27993 7.78545 1.88361 7.402 2.26707L3.28936 6.36589L17.8891 6.36589C18.4237 6.36502 18.8486 6.80375 18.8486 7.33834C18.8486 7.87293 18.4237 8.29784 17.8891 8.29784H3.29022L7.402 12.4105Z"
										    fill="#009FE3"/>
									</svg>
									Go back
								</span>
								<fieldset>
									<div className={"field"}>
										<h4>You’re interested in</h4>
										<ul>
											<li>
												<label>
													<input
														type={"checkbox"}
														name={"interest_in_1"}
														value={"Product Discovery"}
														onChange={handleChange}
														checked={formData.interest_in_1 === 'Product Discovery' ? 'checked' : '' }
													/>{" "}
													<span>Product Discovery</span>
												</label>
											</li>
											<li>
												<label>
													<input
														type={"checkbox"}
														name={"interest_in_2"}
														value={'Product Design'}
														onChange={handleChange}
														checked={formData.interest_in_2 === 'Product Design' ? 'checked' : '' }
													/>{" "}
													<span>Product Design</span>
												</label>
											</li>
											<li>
												<label>
													<input
														type={"checkbox"}
														name={"interest_in_3"}
														value={"Product Development"}
														onChange={handleChange}
														checked={formData.interest_in_3 === 'Product Development' ? 'checked' : '' }
													/>{" "}
													<span>Product Development</span>
												</label>
											</li>
											<li>
												<label>
													<input
														type={"checkbox"}
														name={"interest_in_4"}
														value={"Product Growth"}
														onChange={handleChange}
														checked={formData.interest_in_4 === 'Product Growth' ? 'checked' : '' }
													/>{" "}
													<span>Product Growth</span>
												</label>
											</li>
										</ul>
									</div>
									<div className={'field'}>
									<textarea
										name={'message'}
										placeholder={'Tell us about your project…'}
										value={formData.message}
										onChange={handleChange}
									/>
									</div>
									<div className={'field'}>
										<input type={'text'} name={'budget'}
										       placeholder={'Budget expectations?'}
										       value={formData.budget}
										       onChange={handleChange}
										/>
									</div>
									<button className={"btn btn-1"} onClick={(e) => {
										e.preventDefault();
										goToStep(4)
									}}>Submit
									</button>
								</fieldset>
							</div>
							<div className={'step align-center step-4 ' + (step === 4 ? 'active' : '')}>
								<h2>Thanks!</h2>
								<p>Your message is sent to our amazing team and we will get in contact with you
									soon.</p>
								<span className={'btn btn-2'} onClick={toggleContact}>
									back to website
								</span>
								<span className={'btn btn-1'}  onClick={(e) => {
									e.preventDefault();
									goToStep(1)
								}}>
									reset form
								</span>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
